import { addMilliseconds, addSeconds, eachDayOfInterval, eachHourOfInterval, endOfDay, endOfHour, format, startOfDay, startOfHour } from 'date-fns'
import { Box, Tooltip, Typography } from '@mui/material';

export class CalendarViewFunctions {

    getHourInterval = (startDate) => {
        let hourInterval = eachHourOfInterval({ start: startOfDay(startDate), end: endOfDay(startDate) });
        // const formattedDays = dayInterval.map(date => format(date, dayFormat));
        return hourInterval
    }

    getHourIntervalWithFormat = (startDate, dayFormat, packageRate) => {
        let startTimeDate = addSeconds(startOfDay(startDate), packageRate?.timeFrom)
        let endTimeDate = addSeconds(startOfDay(startDate), packageRate?.timeTo)
        let dayInterval = eachHourOfInterval({ start: startOfHour(startTimeDate), end: endOfHour(endTimeDate) });
        const formattedDays = dayInterval.map(date => format(date, dayFormat));
        return formattedDays
    }

    getTableHeaderWithHours = async () => {
        // const startOfYear = new Date(year, month, 1);
        // const endOfYear = new Date(year, month + 1, 0);
        // const allDaysOfYear = getDayInterval(startOfYear, endOfYear);

        const formattedDaysOfYear = this.getHourInterval(new Date());

        let startColumn = {
            accessorKey: "categories", header: 'Package Name', Header: ({ column }) => {
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>{column.columnDef.header}</Typography>
                    </Box>
                )
            },
        }
        let tableHeader = formattedDaysOfYear.map((day, index) => ({
            accessorKey: format(day, "EEE dd MMM yyyy HH"), header: format(day, "EEE dd MMM yyyy HH"), Header: ({ column }) => {
                // console.log("column", column)
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        {/* <Typography sx={{ lineHeight: "15px" }}>{format(day, "EEE")}</Typography>
                        <Typography sx={{ lineHeight: "20px", fontWeight: "bold" }}>{format(day, "dd")}</Typography> */}
                        <Typography sx={{ lineHeight: "15px" }}>{format(day, "HH")}:00</Typography>
                    </Box>
                )
            },
        }))
        tableHeader.splice(0, 0, startColumn);
        return tableHeader
    }


    getCalendarData = async (packageRatesData, onEditClick, onPackageNameClicked) => {
        try {
            let output = []
            const result = Object.groupBy(packageRatesData, ({ packagesName,packages }) => packagesName || packages?.name);
            console.log("result",result)
            for (let packageName in result) {
                let packageRates = {
                    "categories": <span style={{cursor: "pointer"}} onClick={()=>onPackageNameClicked({id: result[packageName][0]["packagesId"] || result[packageName][0]["packages"]["id"] , name: packageName})}>{packageName}</span>,
                    "subRows": []
                }
                for (let packageRate of result[packageName]) {
                    if (packageRate?.timeFrom < packageRate?.timeTo) {

                        let colorCode = { bgColor: "rgba(57, 181, 74, 0.7)", color: '#39B54A' }
                        const dayIntervals = this.getHourIntervalWithFormat(new Date(), 'EEE dd MMM yyyy HH', packageRate)
                        const divPlacementIndex = (Math.ceil((dayIntervals.length / 2)) - 1)
                        const finalRateData = dayIntervals.reduce((acc, day, index) => {
                            // const subRowIndex = rates.subRows.findIndex(existingRate => existingRate.categories === packageRate.bookingSource);
                            let element = <Tooltip arrow title={<div><div>Package Rate Id : {packageRate.id}</div><div>Package Name : {packageName}</div></div>}>
                                <div data-meta={packageRate?.id} onClick={() => onEditClick(packageRate)} style={{ margin: "5px 0px", display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: '20px', borderBottomLeftRadius: (index === 0) && "4px", borderTopLeftRadius: (index === 0) && "4px", borderTopRightRadius: (index === (dayIntervals.length - 1)) && "4px", borderBottomRightRadius: (index === (dayIntervals.length - 1)) && "4px", color: colorCode?.color, backgroundColor: colorCode?.bgColor }}></div>
                            </Tooltip>
                            acc[day] = element
                            return acc;
                        }, {})

                        packageRates.subRows.push({
                            categories: packageRate.id,
                            ...finalRateData
                        });
                    }

                }
                output.push(packageRates)
            }
            console.log("output", output)
            return output
        } catch (error) {
            console.error("Error Getting Calendar Data:", error)
        }
    }




}